import * as Yup from 'yup';
import { EMAIL_REGEX } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';
import { requiredPostalCode } from './postalCodeSchema';
import { FleetPaymentMode } from '../utils/enums';
import { isValidFleetDiscountPercent } from '../utils/locationFleetSettings';

// Validation schema for Location Info
export const locationInfoSchema = Yup.object().shape({
    locationName: Yup.string().required(CommonMessages.location_name_required),
    email: Yup.string()
    .matches(EMAIL_REGEX, CommonMessages.email_invalid)
    .required(CommonMessages.email_required),
    timezoneOffset: Yup.string().required(CommonMessages.timezone_required),

    address1: Yup.string().when('hasDefaultAddress', {
        is: (val: boolean) => !val,
        then: (schema) => schema.required(CommonMessages.address_required),
        otherwise: (schema) => schema.notRequired(),
    }),
    city: Yup.string().when('hasDefaultAddress', {
        is: (val: boolean) => !val,
        then: (schema) => schema.required(CommonMessages.city_required),
        otherwise: (schema) => schema.notRequired(),
    }),
    country: Yup.string().when('hasDefaultAddress', {
        is: (val: boolean) => !val,
        then: (schema) => schema.required(CommonMessages.country_required),
        otherwise: (schema) => schema.notRequired(),
    }),

    state: Yup.string().when('hasDefaultAddress', {
        is: (val: boolean) => !val,
        then: (schema) => schema.required(CommonMessages.state_required),
        otherwise: (schema) => schema.notRequired(),
    }),
    zipcode: Yup.string().when('hasDefaultAddress', {
        is: (val: boolean) => !val,
        then: () => requiredPostalCode(),
        otherwise: (schema) => schema.notRequired(),
    }),
    hasDefaultAddress: Yup.boolean(),
    enableFleetDiscount: Yup.boolean(),
    fleetDiscount: Yup.string().when('enableFleetDiscount', {
        is: true,
        then: (schema) =>
            schema
                .required(CommonMessages.fleet_discount_required)
                .test('valid-fleet-discount', CommonMessages.fleet_discount_invalid, (value) =>
                    isValidFleetDiscountPercent(value)
                ),
        otherwise: (schema) => schema.notRequired(),
    }),
    fleetPaymentMode: Yup.number()
        .nullable()
        .when('enableFleetDiscount', {
            is: true,
            then: (schema) =>
                schema
                    .required(CommonMessages.fleet_payment_mode_required)
                    .oneOf(
                        [FleetPaymentMode.CreditCard, FleetPaymentMode.ByCheck],
                        CommonMessages.fleet_payment_mode_required
                    ),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
});
